/* eslint-disable */
/**
 * @author Leonel Martinez
 * @module interchange
 * @fileoverview `Vuex interchange module`
 * @see Interchange.vue component
 */
import { interchangeService, inquiryService } from "@/services";
import { MESSAGES, hasNestedProperty, router, ROUTES } from "@/utils";
import { rootAction } from "../index";

const storage = JSON.parse(
  localStorage.getItem(process.env.VUE_APP_LOCALSTORAGE_DATA)
);

export const interchange = {
  namespaced: true,
  state: {
    interChangeNum: storage?.interchange?.interChangeNum || "",
    wildcardResults: [],
    pagination: storage?.interchange?.pagination || [],
    groups: storage?.interchange?.groups || [],
  },
  getters: {},
  actions: {
    /**
     * @description Get the results for wildcard inquiries.
     * @param {number} interchangeNum
     * @returns {Promise} with the results set.
     */
    GET_WILDCARD_RESULTS: async ({ dispatch, commit, rootAction }, interChangeNum) => {
      dispatch("spinner/TOGGLE_SPINNER", { active: true }, rootAction);

      const response = await interchangeService.search(interChangeNum);

      if (response.statusText != "OK") {
        if (response.status === 403)
          dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.WILDCARD_SEARCH_ERROR, rootAction);
        else
          dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.ERRORS.WILDCARD_SEARCH, rootAction);
      }
      else {
        const parts = response.data;

        commit("SET_WILDCARD_RESULTS", parts);
      }

      dispatch("spinner/TOGGLE_SPINNER", { active: false }, rootAction);
    },
    /**
     * @description Set the results.
     * @param {object} payload
     */
    SET_INTERCHANGE_RESULTS: ({ commit }, payload) => {
      commit("SET_INTERCHANGE_RESULTS", payload);
      if (router.app.$route.name != 'interchange-results')
        router.push({ name: 'interchange-results', params: {provider: rootState.settings.skin.provider}})
    },
    SET_INTERCHANGE_NUM: ({ commit }, interchange_number) => {
      commit("SET_INTERCHANGE_NUM", interchange_number);
    },
    /**
     * @description Set the results.
     * @param {number} interChangeNum
     * @returns {Promise} 
     */
    GET_INTERCHANGE: async ({ dispatch, commit, rootState }, {page, size, group_by, interChangeNum }) => {
      dispatch("spinner/TOGGLE_SPINNER", { active: true }, rootAction);

      // Save the requested interchangeNum


      const response = await inquiryService.inquiry(page, size, group_by,{interChangeNum });

      if (response.statusText != 'OK') {
        dispatch("spinner/TOGGLE_SPINNER", { active: false }, rootAction);
        dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.SERVER_ERROR, rootAction);
        return;
      }

      const interchangeParts = response.data;

      if (interchangeParts.partsResult?.length) {
        const pagination_inquiry = interchangeParts;
        commit("SET_PAGINATION_INQUIRY", pagination_inquiry)
        const groups = interchangeParts.partsResult
        console.log("interchnage", groups)
        commit("SET_PARTS", groups);
        if (router.app.$route.name != 'interchange-results')
          router.push({ name: 'interchange-results', params: {provider: rootState.settings.skin.provider}})
      }
      else
        dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.EMPTY_INTERCHANGE, rootAction);
        
      dispatch("spinner/TOGGLE_SPINNER", { active: false }, rootAction);
    },
    /**
     * @description Toggles the basket on the catalog lookup
     * @see DefaultCatalog.vue
     * @param {string} model Could be `partGroupBasket` or `partTypesBasket`
     * @param {object} item { id, name }
     */
     TOGGLE_PART_SELECTION({ commit },part) {
      commit("TOGGLE_PART_SELECTION", part);
    },
  },
  mutations: {
    SET_INTERCHANGE_NUM(state, interChangeNum) {
      state.interChangeNum = interChangeNum;
    },
    SET_WILDCARD_RESULTS(state, results) {
      state.wildcardResults = results;
    },
    SET_INTERCHANGE_RESULTS(state, payload) {
      state.interchangeResults = payload;
    },
    SET_PARTS(state, groups) {
      state.groups = groups;
    },
    SET_PAGINATION_INQUIRY(state, pagination_inquiry) {
      state.pagination = pagination_inquiry
    },
    // Part parameter is optional, if not provided it will use the indexes to find the part
    TOGGLE_PART_SELECTION(state, part) {
      part.selected = !part.selected
      let selected = [{
        name: 'Selected Parts',
        parts: []
      }];
        state.groups.forEach(group => group.parts.forEach(part => part.selected && selected[0].parts.push(part)));
      
      return state.partListBasket = selected;
    },
  }
};
